/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDRadiusUpLeftIcon24Solid = forwardRef('ArrowDRadiusUpLeftIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M7.69 2.84a1.5 1.5 0 0 1 2.12 2.12L5.772 9h5.73C17.298 9 22 13.701 22 19.5v1a1.5 1.5 0 0 1-3 0v-1a7.5 7.5 0 0 0-7.5-7.5H5.77l4.04 4.04a1.5 1.5 0 1 1-2.122 2.12l-5.185-5.185a3.5 3.5 0 0 1 0-4.95l5.185-5.186Z" })));
});
